<app-layout type="blue">
    <div id="mfa-setup">
        <h1>{{ 'mfastatus.title' | translate }}</h1>
        <app-icon-title-underline />

        <div class="content">
            <app-toggle [checked]="checked" (checkedChange)="toggleMfa($event)" />
            <p>{{'mfastatus.text' | translate}}</p>
        </div>

        @if (error) {
        <div class="error-message">
            <app-icon-warning />&nbsp;
            {{'mfastatus.error' | translate }}
        </div>
        }

        <div class="button-group">
            <div class="action">
          @if(loading) {
          <app-spinner></app-spinner>
          } @else {
                <app-button variant="accent">
                    <button (click)="submit()" type="submit" data-testid="mfa-status-submit">{{ 'mfastatus.submit' |
                        translate }}</button>
                </app-button>
            }
            </div>
        </div>
    </div>
</app-layout>
